import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import globalValuesService from "../../../../services/globalValuesService";
import GlobalValuesForm from "./forms/GlobalValuesForm";

function GlobalValuesAddEdit() {
  const { id } = useParams();
  let history = useHistory();

  const [formData, setData] = useState({
    GS_ID: 0,
    name: "",
    columnName: "",
    columnValue: "",
  });

  const getData = async () => {
    const result = await globalValuesService.getOne(id);
    if (result) setData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveGlobalValues = async (data) => {
    const postData = {
      Id: id,
      ColumnName: data.columnName,
      columnValue: data.columnValue,
    };

    if (id) {
      const result = await globalValuesService.update(postData);
      if (result.success === true) history.goBack();
    } else {
      history.goBack();
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Global Values </h4>
      <hr />
      <GlobalValuesForm formData={formData} submitForm={saveGlobalValues} />
    </div>
  );
}

export default GlobalValuesAddEdit;
